import {Box, HStack, Image, VStack} from 'platform/foundation';

import {useParams} from 'react-router-dom';

import {isNotNil} from 'ramda';

import {suffixTestId, TestIdProps, useNavigate, useOnMount} from 'shared/web';

import {LanguageSwitcher} from '../../components/Layout/components/Header/components/LanguageSwitcher';
import {PageBackgroundGradient} from '../../components/PageBackgroundGradient/PageBackgroundGradient';
import {useCreateBatchMutation} from '../../store/importApi';
import {handleApiError} from '../../utils/handleApiError';
import {getImportBatchPath, getImportPath} from '../../utils/routing';
import {ImportResultView} from './components/ImportResultView';
import {ImportUploadForm} from './components/ImportUploadForm';

export function ImportPage(props: TestIdProps) {
  const params = useParams<{batchId?: string}>();
  const navigate = useNavigate();
  const [createBatch] = useCreateBatchMutation();

  useOnMount(() => {
    document.getElementById('loading-screen')?.remove();
  });

  const handleImport = (file: File, market: string) => {
    createBatch({
      body: {file, market},
    })
      .unwrap()
      .then((response) => {
        navigate(getImportBatchPath(response.id));
      })
      .catch(handleApiError);
  };

  const handleBack = () => {
    navigate(getImportPath());
  };

  const {batchId} = params;

  return (
    <>
      <Box backgroundColor="palettes.blue.70.100" paddingHorizontal={6}>
        <HStack height={12} align="center" justify="space-between">
          <Image src="assets/images/logo.svg" maxWidth={125} alt="Logo" />
          <LanguageSwitcher data-testid={suffixTestId('languageSwitcher', props)} />
        </HStack>
      </Box>

      <PageBackgroundGradient data-testid={suffixTestId('background', props)}>
        <VStack shrink={1} maxWidth={315} width="100%" align="center">
          {isNotNil(batchId) ? (
            <ImportResultView
              batchId={batchId}
              onBack={handleBack}
              data-testid={suffixTestId('result', props)}
            />
          ) : (
            <ImportUploadForm
              onImport={handleImport}
              data-testid={suffixTestId('uploadForm', props)}
            />
          )}
        </VStack>
      </PageBackgroundGradient>
    </>
  );
}
